
import React from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { useFavorites } from '@/context/FavoritesContext';
import { exhibits } from '@/data';
import ExhibitCard from '@/components/ExhibitCard';
import { Heart } from 'lucide-react';

const Favorites = () => {
  const { t } = useLanguage();
  const { favorites } = useFavorites();
  
  const favoriteExhibits = exhibits.filter(exhibit => favorites.includes(exhibit.id));
  
  return (
    <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-20 pt-8 relative">
      {/* Abstract shapes in background */}
      <div className="agam-shape agam-shape-1"></div>
      <div className="agam-shape agam-shape-3"></div>
      
      <div className="bg-gradient-to-r from-museum-shapes-red/30 to-museum-shapes-purple/20 py-4 px-6 rounded-xl mb-6">
        <h1 className="section-title mb-0 after:hidden">{t('favorites')}</h1>
      </div>
      
      {favoriteExhibits.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 relative z-10">
          {favoriteExhibits.map(exhibit => (
            <ExhibitCard key={exhibit.id} exhibit={exhibit} />
          ))}
        </div>
      ) : (
        <div className="bg-white rounded-xl shadow-md text-center py-16 px-4 relative z-10">
          <div className="relative inline-block mb-6">
            <div className="absolute inset-0 bg-gradient-to-br from-museum-shapes-red to-museum-shapes-orange opacity-20 animate-pulse rounded-full"></div>
            <Heart className="h-20 w-20 mx-auto text-museum-shapes-red relative z-10" />
          </div>
          <h2 className="text-2xl font-display font-bold mb-2">{t('no_favorites')}</h2>
          <p className="text-gray-600 max-w-md mx-auto">
            {t('no_favorites')}
          </p>
        </div>
      )}
    </div>
  );
};

export default Favorites;
